// extracted by mini-css-extract-plugin
export var banner = "_gz-0";
export var closeButton = "_gz-2";
export var greenCheckmark = "_gz-3";
export var hereLink = "_gz-4";
export var titleIcon = "_gz-1";